import { constructServiceURL } from '../../core/modules/common/tools/URLTools';
import {
  get, formatRequestParams,
  destroy,
  post,
} from '../request';

export const fetchUsers = ({ options }) => get(constructServiceURL({
  endpoint: 'getUsers',
}), formatRequestParams(options));


export const deleteUser = async (samAccountName) => {
  await destroy(constructServiceURL({
    endpoint: 'deleteUser',
    params: {
      samAccountName,
    },
  }));

  return samAccountName;
};

export const fetchUserRoles = (samAccountName) => get(constructServiceURL({
  endpoint: 'userRoles',
  params: { samAccountName },
}));

export const editUserRoles = (data) => post(constructServiceURL({
  endpoint: 'userRoles',
  params: { samAccountName: data.samAccountName },
}), {roles: data.roleIds});
